//@ts-check
import _ from 'lodash';
/*
direct通知設定用のクラスオブジェクト。
「_」付きの変数を直接取得・変更してはならない。
(プライベート宣言はESLint非対応のため未使用)
*/

export default class DirectNoticeUnapprovedWorkSetting {

  _talk_id = null;
  _send_schedule_works_time = null;
  _send_result_works_time = null;
  _use_partner_company_approval_flag = 0;

  constructor(directNoticeSettingData) {
    this._talk_id = directNoticeSettingData['talk_id'];
    this._send_schedule_works_time = directNoticeSettingData['send_schedule_works_time'];
    this._send_result_works_time = directNoticeSettingData['send_result_works_time'];
    this._use_partner_company_approval_flag = directNoticeSettingData['use_partner_company_approval_flag'];
  }

  get talk_id() {
    return this._talk_id;
  }

  get send_schedule_works_time() {
    return this._send_schedule_works_time;
  }

  get send_result_works_time() {
    return this._send_result_works_time;
  }

  get use_partner_company_approval_flag() {
    return this._use_partner_company_approval_flag;
  }

  isNoticeEnabled() {
    return this._use_partner_company_approval_flag === 1
  }

  isNoticeDisabled() {
    return this._use_partner_company_approval_flag === 0
  }

  isConfigured() {
    return this._talk_id !== null
  }
}



// WEBPACK FOOTER //
// ./src/services/directNotice/UnapprovedWorkSetting.js